import { AxiosError, isCancel } from "axios";

// Custom Error Types

export class MaxRetriesError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MaxRetriesError";
  }
}

// Raised when the refresh token itself was refused, so no retry can succeed
// and the user is on their way to the login page.
export class SessionExpiredError extends Error {
  constructor(message: string = "Session expired") {
    super(message);
    this.name = "SessionExpiredError";
  }
}

/**
 * Whether a failed request deserves an error-level log. Only a server fault
 * (5xx) or an unreachable API does: a 4xx is the API answering, a cancelled
 * request is the page moving on, and an ended session is already being
 * handled by the sign-out that raised it.
 */
export const isReportableRequestError = (error: unknown): boolean => {
  if (error instanceof SessionExpiredError) return false;
  if (isCancel(error)) return false;
  if (error instanceof AxiosError) {
    const status = error.response?.status;
    return status === undefined || status >= 500;
  }
  return true;
};
